/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-02-09 17:16:10
 */
// 首页学习进度配置
export const HomepageProgressConfigModuleKey = 'homepage-progress-config'
// 首页学习进度标题
export const HomepageProgressTitleConfigModuleKey = 'homepage-progress-title-config'
// 首页是否展示讲师
export const HomepageLucturerConfigModuleKey = 'homepage-pc-lecturers-config'
// 是否展示课程价格
export const IsShowCoursePriceConfigModuleKey = 'homepage-course-price-config'
// 是否仅展示LOGO
export const OnlyShowLogoConfigModuleKey = 'homepage-onlyshowlogo-config'
// 默认学习进度标题
export const defaultHomeLearningProgressTitle = '学习进度'
// 默认学习进度series
export const defaultHomeLearningProgressSeries = [
  { sort: 0, title: '用户注册' },
  { sort: 1, title: '培训报名' },
  { sort: 2, title: '课程选择' },
  { sort: 3, title: '费用支付' },
  { sort: 4, title: '课程学习' },
  { sort: 5, title: '课程考核' },
  { sort: 6, title: '证书发放' }
]
